module.exports = __webpack_public_path__ + "static/media/dashboardDarkActive.924fa5d5.svg";